<div [ngClass]="footerContainerCssClasses"
     class="
    d-flex
    flex-column flex-md-row
    align-items-center
    justify-content-between
     container-fluid
  ">
  <!-- begin::Copyright  -->
  <div class="text-dark order-2 order-md-1">
    <span class="text-muted fw-bold me-2"> 2021 © </span>
    <a class="text-gray-800 text-hover-primary cursor-pointer" href="https://bnsights.com"
       target="_blank">
      Bnsights
    </a>
  </div>
  <!-- end::Copyright  -->

</div>
